import ConditionalCard from 'Components/Reusable/Cards/ConditionalCard';
import React, { Fragment ,useEffect,useState} from 'react';
import { conditionsArchived } from 'Utils/options';
import hoohoo from 'Assets/img/holders/hoohoo.svg';
import {useHistory } from 'react-router-dom'
import MilestoneAchievedCard from 'Components/milestones/MilestoneAchievedCard'
import { Routes } from 'Utils/Route';
import { saveMilestone } from 'ReduxStore/milestones/Action';

import {useDispatch, useSelector} from 'react-redux';
import { formatDate, getMilestoneAchievedList, yearCalculatorToMonths } from 'Helpers';
import { RootState } from 'ReduxStore/store';
import { GetAllKids } from 'ReduxStore/children/Action';


const list = [
	{ id: 0, name: 'This week' },
	{ id: 1, name: 'Last week' },
	{ id: 2, name: '2 weeks ago' },
	{ id: 3, name: '3 weeks ago' },
	{ id: 4, name: '1 month ago' },
	{ id: 5, name: '1 and a half month ago' },
	{ id: 6, name: '2 months ago' },
	{ id: 7, name: '3 months ago' },
	{ id: 8, name: '4 months ago' }
];



interface AchievedProps {
	onClick?:any,
	id?:any,
	open?:any,
	setOpen?:any,
	milestoneCategoryId?:any
}
interface RouteParams {
	id: string;
}
const Archived = ({id,setOpen,milestoneCategoryId}:AchievedProps) => {

	useEffect(() => {
		dispatch(GetAllKids());
	}, [])
	const childName = localStorage.getItem('currentChild');
	const children = useSelector((state: RootState) => state.children.children);
	const getChildId = JSON.parse(localStorage.getItem('currentChildId') || '{}');
	const child = children && children.find(child => child.id === parseInt(getChildId));
	const childAge = yearCalculatorToMonths(child?.dateOfBirth)
	const l = getMilestoneAchievedList(child?.dateOfBirth)
	// eslint-disable-next-line no-console
	console.log("dddd ->",l)
	const [show,setShow] = useState(false);
	const [selected,setSelected] = useState('');
	const dispatch = useDispatch();
	const history = useHistory();
	const handleOpen = () => {
		setShow(true)
	}
	const handleClose = () => {
		setShow(false)
	}
	const onClick = (value:string) => {
		// eslint-disable-next-line no-console
		console.log("value is --->",value)
		setSelected(value)
		
		setShow(false)
	}
	const handleModalClick = (condition: string) =>
	
		condition === 'Confirm' ? dispatch(saveMilestone(id,selected)) &&history.push(`/milestones/${milestoneCategoryId}`)  : setOpen();
	return (
		<Fragment>
			<ConditionalCard
				conditions={conditionsArchived}
				information="Milestone achieved!"
				// heading="When was this achieved?"
				image={hoohoo}
				onClick={handleModalClick}
			>
				<div className="d-flex justify-content-center align-items-center my-3">
				
				<MilestoneAchievedCard itemList={child && getMilestoneAchievedList(child?.dateOfBirth)} handleOpen= {handleOpen} onClick={onClick} show={show} currentValue={selected} />
				</div>
			</ConditionalCard>
		</Fragment>
	);
};

export default Archived;


